import { t } from 'i18next'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { InputDatePicker, InputText } from '../../../components/Main'
import Validation, {
  correctionNoteMaxLength,
  correctionNoteMinLength,
  titleMaxLength,
  titleMinLength,
} from '../../../constant/global/validation'
import {
  InteractorCorrectionCreate,
  InteractorCorrectionSearch,
  InteractorOrderSearch,
} from '../../../interactors/Main'
import InteractorShippingHeaderSearch from '../../../interactors/transaction/shipping/InteractorShippingHeaderSearch'
import OrderCorrectionItemsSection from './OrderCorrectionItemsSection'
import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { cleanNumber, compareSameData, formatDate } from '../../../utility/Helpers'

const OrderCorrectionCreate = () => {
  const pathSegments = window.location.pathname.split('/')
  const uid = pathSegments[pathSegments.length - 1]
  const lastCorrectionDate = useRef(null)
  const { account } = useSelector((state) => state.account)
  const { correctionCreate } = InteractorCorrectionCreate()
  const { orderSearch } = InteractorOrderSearch()
  const { correctionSearch } = InteractorCorrectionSearch()
  const { shippingHeaderSearch } = InteractorShippingHeaderSearch()
  const { validationInputText, validationInputChar } = Validation()
  const [loading, setLoading] = useState(true)
  const [loadingCorrection, setLoadingCorrection] = useState(true)
  const [loadingShipping, setLoadingShipping] = useState(true)
  const [isAllocated, setIsAllocated] = useState(false)
  const [isAllocatedAmount, setIsAllocatedAmount] = useState(false)
  const [correctionItemsBefore, setCorrectionItemsBefore] = useState([])
  // const [initShippingCost, setInitShippingCost] = useState(0)
  // const [initInsuranceCost, setInitInsuranceCost] = useState(0)
  const [correctionBeforeTotal, setCorrectionBeforeTotal] = useState({
    shippingCost: 0,
    shippingCostBefore: 0,
    shippingCostBilled: 0,
    insuranceCost: 0,
    insuranceCostBefore: 0,
    insuranceCostBilled: 0,
    totalOrder: 0,
    totalPayment: 0,
    unappliedDownPayment: 0,
  })
  const [isAlreadyCorrectionData, setIsAlreadyCorrectionData] = useState(null)
  const [correctionItemsAfter, setCorrectionItemsAfter] = useState([])
  const [correctionAfterTotal, setCorrectionAfterTotal] = useState({
    shippingCost: 0,
    shippingCostBefore: 0,
    shippingCostBilled: 0,
    insuranceCost: 0,
    insuranceCostBefore: 0,
    insuranceCostBilled: 0,
    totalOrder: 0,
    totalPayment: 0,
    unappliedDownPayment: 0,
  })
  const [orderData, setOrderData] = useState({})
  const [dataShipping, setDataShipping] = useState([])
  const [detailCorrection, setDetailCorrection] = useState({
    created_date: new Date(),
  })
  const [error, setError] = useState({
    correction_note: null,
    created_date: null,
  })

  const isOrderReady = !!orderData.uid
  const isShippingReady = dataShipping?.items !== undefined
  const billRaw = orderData?.bill ?? '[]'
  const [finalResult, setFinalResult] = useState(null) // null | 'ada' | 'gada

  const checkBillStatus = useMemo(() => {
    try {
      return JSON.parse(billRaw).some((b) => ['ISSUED', 'PROCESSED'].includes(b.status))
    } catch {
      return false
    }
  }, [billRaw])

  const hasShippedStatus = useMemo(() => {
    if (!Array.isArray(dataShipping?.items) || dataShipping.items.length === 0) return false
    return dataShipping.items.some(
      (it) => !['DELIVERED', 'CANCELLED', 'CORRECTION'].includes(it.initial_status),
    )
  }, [dataShipping?.items])

  const payloadCorrectionSearch = useMemo(
    () => ({
      page: 1,
      limit: 5,
      keywords: {
        text_search: '',
        status: '',
        account_uid: '',
        store_uid: '',
        uid: '',
        transaction_uid: uid,
      },
    }),
    [uid],
  )

  const payloadOrderSearch = useMemo(
    () => ({
      page: 1,
      limit: 5,
      keywords: {
        uid,
      },
    }),
    [uid],
  )

  const [payloadShipping] = useState({
    page: 1,
    limit: 50,
    keywords: {
      text_search: '',
      uid: '',
      transaction_uid: uid,
      account_uid: account?.uid,
      status: '',
      store_uid: '',
    },
  })

  const handleResponseShipping = useCallback((data) => setDataShipping(data), [])

  useEffect(() => {
    if (loadingShipping) {
      shippingHeaderSearch(payloadShipping, handleResponseShipping, setLoadingShipping)
    }
  }, [shippingHeaderSearch, handleResponseShipping, loadingShipping, payloadShipping])

  useEffect(() => {
    if (!isOrderReady || !isShippingReady) return

    if (finalResult !== null) return

    const shouldStay =
      (!hasShippedStatus && !checkBillStatus) ||
      (orderData?.bill === undefined && dataShipping?.items === null)

    setFinalResult(shouldStay)
  }, [
    isOrderReady,
    isShippingReady,
    hasShippedStatus,
    checkBillStatus,
    dataShipping?.items,
    finalResult,
    orderData?.bill,
  ])

  useEffect(() => {
    if (finalResult === null) return

    if (!finalResult) window.location.href = `/order/view/${uid}`
  }, [finalResult, uid])

  const handlerInput = (e) => {
    const { name, value } = e.target

    let message = null
    if (name === 'correction_note') {
      message = validationInputChar(
        value,
        correctionNoteMinLength,
        correctionNoteMaxLength,
        t(`form.${name}`),
      )
    } else {
      message = validationInputText(value, titleMinLength, titleMaxLength, t(`form.${name}`))
    }
    setError((prev) => ({ ...prev, [name]: message }))

    setDetailCorrection({
      ...detailCorrection,
      [name]: value,
    })
  }
  const datePickHandler = (value) => {
    setDetailCorrection({
      ...detailCorrection,
      created_date: value,
    })
  }
  const parsingItems = () => {
    const correctionItems = []
    let sort = 1
    let cloneItemsAfter = [...correctionItemsAfter]
    let filterDataAfter = cloneItemsAfter.filter((item) => item.is_deleted !== 1)

    const afterMap = {}
    filterDataAfter.forEach((item) => {
      afterMap[item.product_uid] = item
    })

    correctionItemsBefore.forEach((beforeItem) => {
      const afterItem = afterMap[beforeItem.product_uid]
      correctionItems.push({
        product_title: beforeItem.product_title,
        transaction_uid: uid,
        transaction_item_uid: `${beforeItem.product_trx_uid}`,
        lines_type: afterItem
          ? beforeItem.product_price === afterItem.product_price &&
            beforeItem.product_quantity === afterItem.product_quantity
            ? 'UNCHANGED'
            : 'CHANGED'
          : 'REMOVED',
        product_minimum_order_quantity: beforeItem.product_minimum_order_quantity,
        before_product_uid: beforeItem.product_uid,
        before_product_unit_type: beforeItem.product_unit_type,
        before_product_quantity: beforeItem.product_quantity,
        before_product_price: beforeItem.product_price,
        after_product_uid: afterItem ? afterItem.product_uid : '',
        after_product_unit_type: afterItem ? afterItem?.product_unit_type : '',
        after_product_quantity: afterItem ? afterItem.product_quantity : '',
        after_product_price: afterItem ? afterItem.product_price : '',
        is_deleted: afterItem ? afterItem.is_deleted : 1,
        status_item: 'ready',
        product_amount_allocated: afterItem
          ? trimDecimal(afterItem.product_amount_allocated, 2)
          : 0,
        sort_number: sort++,
      })
    })

    const beforeUids = correctionItemsBefore.map((item) => item.product_uid)

    correctionItemsAfter.forEach((afterItem) => {
      if (!beforeUids.includes(afterItem.product_uid) && afterItem.is_deleted === 0) {
        correctionItems.push({
          product_title: afterItem.product_title,
          transaction_uid: uid,
          transaction_item_uid: '',
          lines_type: 'ADDED',
          product_minimum_order_quantity: afterItem.product_minimum_order_quantity,
          before_product_uid: '',
          before_product_unit_type: '',
          before_product_quantity: '',
          before_product_price: '',
          after_product_uid: afterItem.product_uid,
          after_product_unit_type: afterItem.product_unit_type || '',
          after_product_quantity: afterItem.product_quantity,
          after_product_price: afterItem.product_price,
          is_deleted: afterItem.is_deleted,
          status_item: 'ready',
          product_amount_allocated: trimDecimal(afterItem.product_amount_allocated, 2),
          sort_number: sort++,
        })
      }
    })
    return correctionItems
  }

  const handleOrderSearch = useCallback((response) => {
    if (response?.items) {
      const item = response.items[0]

      const transactionItems = item?.transaction_items || []
      const corectionItems = transactionItems.map((item) => ({
        product_title: item.product_title,
        product_minimum_order_quantity: item.product_minimum_order_quantity,
        product_quantity: item.product_quantity,
        product_quantity_billed: item.product_quantity_billed,
        product_quantity_before: item.product_quantity,
        product_price: item.product_price,
        product_price_before: item.product_price,
        product_type: item.product_type,
        product_total_price: item.product_quantity * item.product_price,
        product_total_price_before: item.product_quantity * item.product_price,
        product_currency: item.product_price_currency,
        product_uid: item.product_uid,
        product_status: 'existing',
        product_thumbnail: item.product_thumbnail,
        product_trx_uid: item.uid,
        product_unit_type: item.product_unit_type,
        product_pph_billed: item.product_pph_billed,
        product_dp_pph_billed: item.product_dp_pph_billed,
        product_already_paid:
          item.product_price_billed * item.product_quantity_billed - item.product_pph_billed,
        product_already_paid_before:
          item.product_price_billed * item.product_quantity_billed - item.product_pph_billed,
        is_deleted: 0,
        status_item: 'initiate',
        product_amount_allocated: 0,
        product_amount_allocated_original: 0,
        product_amount_allocated_before: 0,
        product_total_down_payment_unapplied:
          item.product_total_down_payment_unapplied - item.product_dp_pph_billed,
      }))
      const corectionBeforeItems = transactionItems.map((item) => ({
        product_title: item.product_title,
        product_quantity: item.product_quantity,
        product_quantity_billed: item.product_quantity_billed,
        product_minimum_order_quantity: item.product_minimum_order_quantity,
        product_quantity_before: item.product_quantity_before,
        product_price: item.product_price,
        product_price_before: item.product_price,
        product_type: item.product_type,
        product_total_price: item.product_quantity * item.product_price,
        product_total_price_before: item.product_quantity * item.product_price,
        product_currency: item.product_price_currency,
        product_uid: item.product_uid,
        product_status: 'existing',
        product_thumbnail: item.product_thumbnail,
        product_trx_uid: item.uid,
        product_unit_type: item.product_unit_type,
        product_pph_billed: item.product_pph_billed,
        product_dp_pph_billed: item.product_dp_pph_billed,
        product_already_paid:
          item.product_price_billed * item.product_quantity_billed - item.product_pph_billed,
        product_already_paid_before:
          item.product_price_billed * item.product_quantity_billed - item.product_pph_billed,
        is_deleted: 0,
        status_item: 'initiate',
        product_amount_allocated: 0,
        product_amount_allocated_original: 0,
        product_amount_allocated_before: 0,
        product_total_down_payment_unapplied:
          item.product_total_down_payment_unapplied - item.product_dp_pph_billed,
      }))
      setDetailCorrection((prev) => ({
        ...prev,
        reference_number_internal: item?.transaction_code,
      }))

      setCorrectionItemsAfter(corectionItems)
      setCorrectionItemsBefore(corectionBeforeItems)

      setOrderData(item)

      // Calculate total price
      const totalUnapplied = corectionItems.reduce(
        (sum, item) => sum + (Number(item.product_total_down_payment_unapplied) || 0),
        0,
      )
      const totalOrder = corectionItems?.reduce((sum, item) => sum + item.product_total_price, 0)

      const totalOrderBefore = corectionBeforeItems?.reduce(
        (sum, item) => sum + item.product_total_price,
        0,
      )

      // const remainShippingCost = Math.max(item?.delivery_cost || 0, 0)
      // const remainInsuranceCost = Math.max(item?.delivery_insurance_cost || 0, 0)
      // setInitShippingCost(remainShippingCost)
      // setInitInsuranceCost(remainInsuranceCost)

      setCorrectionAfterTotal({
        // shippingCost: remainShippingCost,
        shippingCost: item?.delivery_cost,
        shippingCostBefore: item?.delivery_cost || 0,
        shippingCostBilled: item?.delivery_cost_billed || 0,
        // insuranceCost: remainInsuranceCost,
        insuranceCost: item?.delivery_insurance_cost,
        insuranceCostBefore: item?.delivery_insurance_cost || 0,
        insuranceCostBilled: item?.delivery_insurance_cost_billed || 0,
        totalOrder,
        totalPayment:
          totalOrder + (item?.delivery_cost || 0) + (item?.delivery_insurance_cost || 0),
        unappliedDownPayment: totalUnapplied,
      })
      setCorrectionBeforeTotal({
        // shippingCost: remainShippingCost,
        shippingCost: item?.delivery_cost,
        shippingCostBefore: item?.delivery_cost || 0,
        shippingCostBilled: item?.delivery_cost_billed || 0,
        // insuranceCost: remainInsuranceCost,
        insuranceCost: item?.delivery_insurance_cost,
        insuranceCostBefore: item?.delivery_insurance_cost || 0,
        insuranceCostBilled: item?.delivery_insurance_cost_billed || 0,
        totalOrderBefore,
        totalPayment:
          totalOrderBefore + (item?.delivery_cost || 0) + (item?.delivery_insurance_cost || 0),
        unappliedDownPayment: totalUnapplied,
      })
    }
  }, [])

  const totalAlreadyPaidAndProcess = (bill) => {
    let billData = bill && JSON.parse(bill)
    let totalBill = 0

    billData.forEach((item) => {
      if (['PAID', 'PROCESSED', 'ISSUED'].includes(item.status)) {
        totalBill += item.total_amount
      }
    })

    return totalBill
  }

  const trimDecimal = (num, decimalPlaces = 2) => {
    if (typeof num !== 'number' || isNaN(num)) {
      return NaN
    }

    const decimalPart = num % 1 !== 0 ? num.toString().split('.')[1] : null
    if (!decimalPart || decimalPart.length <= decimalPlaces) {
      return num
    }

    return Math.round((parseFloat(num.toFixed(10)) + Number.EPSILON) * 100) / 100
  }

  // function roundTwoDecimals(value) {
  //   return Math.round((value + Number.EPSILON) * 100) / 100
  // }

  // const validateProductQuantities = (items) => {
  //   return items.every((item) => item.after_product_quantity >= item.product_minimum_order_quantity)
  // }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const correctionItems = parsingItems()
    const minSubtotalProduct = 0.5
    const paymentAmountBefore = correctionBeforeTotal?.totalPayment
    const paymentAmountAfter = correctionAfterTotal?.totalPayment
    const payload = {
      created_by: account?.full_name,
      transaction_uid: uid,
      transaction_code: orderData?.transaction_code,
      reference_number_internal: detailCorrection?.reference_number_internal,
      customer_account_uid: orderData?.customer_account_uid,
      customer_company_uid: orderData?.customer_company_uid,
      created_date: formatDate(detailCorrection.created_date, 'YYYY-MM-DD HH:mm:ss'),
      store_uid: orderData?.store_uid,
      delivery_cost_before: correctionBeforeTotal?.shippingCost,
      delivery_cost_after: correctionAfterTotal?.shippingCost,
      delivery_insurance_cost_before: correctionBeforeTotal?.insuranceCost,
      delivery_insurance_cost_after: correctionAfterTotal?.insuranceCost,
      payment_tax_amount_before: 0,
      payment_tax_amount_after: 0,
      payment_additional_before: 0,
      payment_additional_after: 0,
      payment_amount_before: trimDecimal(paymentAmountBefore, 2),
      payment_amount_after: trimDecimal(paymentAmountAfter, 2),
      correction_note: detailCorrection?.correction_note,
      correction_lines: correctionItems,
    }

    // if (!validateProductQuantities(correctionItems)) {
    //   showAlert({
    //     icon: 'error',
    //     message: t('message.minimum_quantity_input'),
    //     reload: false,
    //     timer: 3000,
    //   })
    //   retur
    //
    // }
    if (correctionAfterTotal.totalOrder < minSubtotalProduct) {
      showAlert({
        icon: 'error',
        message: t('message.subtotal_minimum'),
        reload: true,
        timer: 3000,
      })
      return
    }
    const anyZeroPriceAfterCorrection = correctionItems.some(
      (item) => item.after_product_price === 0,
    )
    if (anyZeroPriceAfterCorrection) {
      showAlert({
        icon: 'error',
        message: t('message.less_than_minimum_nominal'),
        reload: true,
        timer: 3000,
      })
      return
    }

    if (
      orderData?.bill &&
      correctionAfterTotal.shippingCost < correctionAfterTotal.shippingCostBilled
    ) {
      showAlert({
        icon: 'error',
        message: t('message.shipping_cost_lower_than_paid'),
        reload: true,
        timer: 3000,
      })
      return
    }

    if (
      orderData?.bill &&
      correctionAfterTotal.insuranceCost < correctionAfterTotal.insuranceCostBilled
    ) {
      showAlert({
        icon: 'error',
        message: t('message.insurance_cost_lower_than_paid'),
        reload: false,
        timer: 3000,
      })
      return
    }

    if (correctionItemsBefore.length < 1 || correctionItemsAfter.length < 1) {
      showAlert({
        icon: 'error',
        message: t('message.no_items_correction'),
        reload: false,
        timer: 3000,
      })
      return
    }

    let checkZeroQuantity = correctionItems.find((item) => item.after_product_quantity === 0)
    if (checkZeroQuantity) {
      showAlert({
        icon: 'error',
        message: t('message.invalid_quantity'),
        reload: false,
        timer: 3000,
      })
      return
    }

    if (
      correctionBeforeTotal?.shippingCost === correctionAfterTotal?.shippingCost &&
      correctionBeforeTotal?.insuranceCost === correctionAfterTotal?.insuranceCost &&
      orderData.transaction_items?.length === correctionItems?.length &&
      compareSameData(correctionItems, 'before_product_price', 'after_product_price') &&
      compareSameData(correctionItems, 'before_product_quantity', 'after_product_quantity')
    ) {
      showAlert({
        icon: 'error',
        message: t('message.no_changed_items_correction'),
        reload: false,
        timer: 3000,
      })
      return
    }

    if (
      orderData?.bill &&
      correctionAfterTotal?.totalPayment < totalAlreadyPaidAndProcess(orderData?.bill)
    ) {
      showAlert({
        icon: 'error',
        message: t('response_message.payment_insufficient'),
        reload: true,
        timer: 3000,
      })
      return
    }

    if (error.created_date || error.correction_note) {
      showAlert({
        icon: 'error',
        message: error.created_date || error.correction_note,
        reload: false,
      })
      return
    }

    if (!detailCorrection?.correction_note) {
      let message = validationInputChar(
        '',
        correctionNoteMinLength,
        correctionNoteMaxLength,
        t(`form.correction_note`),
      )
      showAlert({
        icon: 'error',
        message,
        reload: false,
      })
      return
    }

    const confirm = await confirmationAlert({
      title: t('title.are_you_sure'),
      message: t('message.confirmation_correction_product'),
      icon: 'warning',
    })

    if (confirm) {
      correctionCreate(payload, setLoading, orderData?.uid)
    }
    setLoading(true)
  }

  useEffect(() => {
    if (isAlreadyCorrectionData?.initial_status === 'REQUEST') {
      window.location.href = `/order/correction/${uid}`
    }
  }, [isAlreadyCorrectionData?.initial_status, uid])

  const handleResponse = useCallback((data) => {
    const items = data?.items || []

    const lastApprovedCorrection = items.find((dat) => dat.initial_status === 'APPROVED')

    if (items[0]) setIsAlreadyCorrectionData(items[0])

    if (items[0].initial_status === 'APPROVED') {
      const correctionLines = items[0]?.correction_lines || []

      const correctionMap = new Map(correctionLines.map((line) => [line.after_product_uid, line]))

      setCorrectionItemsAfter((prev) => {
        if (!prev || prev.length === 0) return prev

        const updated = prev.map((item) => {
          const match = correctionMap.get(item.product_uid)
          if (!match) return item

          return {
            ...item,
            status_item: 'assign',
            product_amount_allocated: cleanNumber(match.product_amount_allocated),
            product_amount_allocated_original: cleanNumber(match.product_amount_allocated),
          }
        })

        return updated
      })
    }

    if (lastApprovedCorrection) {
      lastCorrectionDate.current = lastApprovedCorrection.correction_approved_date
    }
  }, [])

  const calculateAllocatedAmount = () => {
    if (!Array.isArray(correctionItemsAfter) || correctionItemsAfter.length === 0) {
      return 0
    }

    const updated = [...correctionItemsAfter]

    const alreadyPaidTotal = updated.reduce((sum, item) => {
      const paid = cleanNumber(item.product_already_paid)
      return sum + paid
    }, 0)

    const unappliedDownPaymentTotal = updated.reduce((sum, item) => {
      const dp = cleanNumber(item.product_total_down_payment_unapplied)
      return sum + dp
    }, 0)

    // const hasDifferenceAmount = updated.some((item) => {
    //   const paid = cleanNumber(item.product_already_paid) || 0
    //   const dp = cleanNumber(item.product_total_down_payment_unapplied) || 0
    //   const totalPaid = dp + paid
    //   const total =
    //     (cleanNumber(item.product_price) || 0) * (cleanNumber(item.product_quantity) || 0)
    //   return total < totalPaid
    // })

    const hasQuantityChanged = updated.some(
      (item) => item.product_quantity !== item.product_quantity_before,
    )

    const hasAddNewProduct = updated.some((item) => item.product_status === 'added')

    const hasDeletedItem = updated.some((item) => item.is_deleted === 1)

    let result = 0
    if (hasQuantityChanged || hasDeletedItem || hasAddNewProduct) {
      let tmp = unappliedDownPaymentTotal + alreadyPaidTotal
      result += tmp
    }
    return trimDecimal(result, 2)
  }

  const handleAllocatedAmount = () => {
    setIsAllocated(false)
    setIsAllocatedAmount(true)
    const totalAllocated = calculateAllocatedAmount()

    if (!Array.isArray(correctionItemsAfter) || correctionItemsAfter.length === 0) {
      return
    }

    const updated = [...correctionItemsAfter]

    const remainingAmountOrder = updated.reduce((sum, item) => {
      if (item.is_deleted === 1) return sum

      const remainingPaid = item.product_quantity * item.product_price

      return sum + (remainingPaid > 0 ? remainingPaid : 0)
    }, 0)

    if (remainingAmountOrder <= 0 || totalAllocated <= 0) {
      setCorrectionItemsAfter(updated)
      return
    }

    for (let i = 0; i < updated.length; i++) {
      const item = updated[i]

      if (item.is_deleted === 1) continue

      const totalAmountPerItem = item.product_quantity * item.product_price
      const remainingAmount = item.product_quantity * item.product_price
      const allocatedRatio = totalAmountPerItem > 0 ? totalAmountPerItem / remainingAmountOrder : 0

      let resultAllocated = allocatedRatio * totalAllocated

      if (remainingAmount < resultAllocated) {
        resultAllocated = remainingAmount
      }
      item.product_amount_allocated_before =
        item.product_amount_allocated === 0
          ? cleanNumber(item.product_amount_allocated_original)
          : cleanNumber(item.product_amount_allocated)

      item.product_amount_allocated = resultAllocated > 0 ? cleanNumber(resultAllocated) : 0
    }

    setCorrectionItemsAfter(updated)
  }

  const hasCorrectionItemsAfter = correctionItemsAfter?.length > 0

  useEffect(() => {
    if (!loadingCorrection) return
    if (!hasCorrectionItemsAfter) return

    correctionSearch(payloadCorrectionSearch, handleResponse, setLoadingCorrection)
  }, [
    loadingCorrection,
    hasCorrectionItemsAfter,
    correctionSearch,
    payloadCorrectionSearch,
    handleResponse,
  ])

  useEffect(() => {
    if (loading && !orderData?.uid) {
      orderSearch(payloadOrderSearch, handleOrderSearch, () => {})
    }
  }, [orderSearch, loading, orderData?.uid, payloadOrderSearch, handleOrderSearch])

  const totalAllocated = trimDecimal(
    correctionItemsAfter.reduce((sum, item) => sum + (item?.product_amount_allocated || 0), 0),
  )

  let finalAllocatedValue = calculateAllocatedAmount() - totalAllocated

  const isAllDeleted = correctionItemsAfter.every((item) => item.is_deleted === 1)

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between mb-3">
        <h6 className="text-primary fw-bold">
          {t('form.correction_main_title')} - {orderData?.transaction_code}
        </h6>
        <Link
          to={'#'}
          onClick={() => {
            window.location = `/order/correction/${orderData?.uid}`
          }}
          className="text-dark btn-outline-secondary btn btn-xs m-2 font-size-12"
        >
          <i className="fas fa-arrow-left px-2"></i> {t('button.back')}
        </Link>
      </div>
      <div className="card p-3 mb-4">
        <div className="row g-3 mb-4">
          <div className="col-md-6 pb-2 pt-1">
            <InputText
              label={t('form.reference_number_internal')}
              value={detailCorrection?.reference_number_internal || ''}
              onChange={handlerInput}
              error={!!error.reference_number_internal}
              errorMsg={error.reference_number_internal}
              name="reference_number_internal"
            />
          </div>
          {lastCorrectionDate.current !== null && (
            <div className="col-md-6 pb-2">
              <label className="font-size-12 font-weight-bold">{t('form.created_date')}</label>
              <InputDatePicker
                initial="DDMMYY"
                required={true}
                changeYear={true}
                onCallback={datePickHandler}
                maxDate={new Date()}
                minDate={new Date(lastCorrectionDate.current || detailCorrection.created_date)}
                startDate={new Date()}
                preventManuallyType={true}
              />
            </div>
          )}
          <div className="col-12 pb-2">
            <InputText
              label={t('form.correction_note')}
              value={detailCorrection?.correction_note || ''}
              onChange={handlerInput}
              error={!!error.correction_note}
              errorMsg={error.correction_note}
              name="correction_note"
              required={true}
            />
          </div>
        </div>
        <OrderCorrectionItemsSection
          label={t('form.correction_product')}
          orderData={orderData}
          items={correctionItemsAfter}
          setItems={setCorrectionItemsAfter}
          totalData={correctionAfterTotal}
          setTotalData={setCorrectionAfterTotal}
          totalAlreadyPaidAndProcess={totalAlreadyPaidAndProcess}
          setIsAllocated={setIsAllocated}
          finalAllocatedValue={finalAllocatedValue}
          isAllocatedAmount={isAllocatedAmount}
          setIsAllocatedAmount={setIsAllocatedAmount}
        />
      </div>

      <div className="text-center mt-4">
        {finalAllocatedValue > 0 || isAllocated ? (
          <button
            className="btn btn-primary px-4 pointer"
            disabled={isAllDeleted}
            onClick={handleAllocatedAmount}
          >
            {t('button.allocation')}
          </button>
        ) : (
          <button className="btn btn-primary px-4 pointer" onClick={handleSubmit}>
            {t('button.save')}
          </button>
        )}
      </div>
    </div>
  )
}

export default OrderCorrectionCreate
